module Tapas.Bindings {
    export class BreadCrumbBack {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

			var ele = $(element);
			var previousMenu = document.getElementById(valueAccessor());
			var thisSubMenu = ele.parent().parent();

			ele.click(function (e) {
				$(previousMenu).addClass('active').show();
				thisSubMenu.fadeOut(200, () => {
					$(previousMenu).nextAll('div').remove()
				});
				e.stopPropagation();
			});
        }
    }
    ko.bindingHandlers['breadCrumbBack'] = new BreadCrumbBack();
}